import React from "react";
import HeaderCities from "../components/HeaderCities";
import ApplianceRemovalFAQs from "../components/ApplianceRemovalFAQs";
import ServicesArea from "../components/ServicesArea";
import UpperFooter from "../components/UpperFooter";
import "../assets/css/services.css";

function ApplianceRemoval() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content=" Need appliance removal services? Our fast, reliable removal service makes disposal easy and stress-free. Hassle-free pickup and eco-friendly recycling included!"
        />
        <base href="/" />

        <link
          rel="preload"
          as="image"
          href="/assets/img/appliance-removal.webp"
          type="image/webp"
        />
        <link
          rel="canonical"
          href="https://junkdroid.com/services/appliance-removal/"
        />

        <title>Appliance Removal | Fast & Reliable Removal | Junk Droid</title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <>
        <HeaderCities />
        {/* ================== Hero Section Start HERE =========================  */}
        <div className="container-fluid madeesay-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12 serve-sec">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Services</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Appliance Removal
                    </li>
                  </ol>
                </nav>
                <h1>
                  Appliance Removal <span>Made Easy</span>
                </h1>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <div className="inner-img">
                  <img
                    src="/assets/img/appliance-removal.webp"
                    alt="Appliance removal"
                  />
                </div>
                <p>
                  Need appliance removal services? We offer same-day appliance
                  removal! From refrigerators to washers and dryers, our
                  hassle-free service makes disposal easy.
                </p>
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 booking-btn">
                    <a href="tel:4085397261">
                      <button type="button" className="btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-telephone-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                          />
                        </svg>{" "}
                        &nbsp; CALL NOW
                      </button>
                    </a>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 rate-sect">
                    <h4>Rated 5.0 on Google</h4>
                    <div className="rating-sec">
                      <span>5.0</span> &nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill ms-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 desk-img">
                <img
                  src="/assets/img/appliance-removal.webp"
                  alt="Appliance removal"
                />
              </div>
            </div>
          </div>
        </div>
        {/* ================== Hero Section End HERE =========================  */}
        {/* ================== First  Section Start HERE =========================  */}
        <hr />
        <div className="container-fluid overview-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="major-heading">
                  Affordable Appliance Removal Services
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  Our expert team at Junk Droid specializes in the safe and
                  efficient removal of old appliances, ensuring a hassle-free
                  experience.
                </p>
                <p className="service-description">
                  We offer convenient pickup and disposal services directly from
                  your home or apartment, making appliance removal effortless.
                  Whether you're upgrading, moving, or just clearing space, we
                  handle everything with care.
                </p>
                <p className="service-description">
                  Committed to eco-friendly disposal, Junk Droid partners with
                  local charities and recycling centers to donate or responsibly
                  recycle usable appliances. Our goal is to reduce waste and
                  promote sustainability, so you can feel confident knowing your
                  old appliances are handled the right way.
                </p>
                {/* ============ */}
                <h3>
                  Why Choose Us
                  <span className="ms-3">for Your Appliance Removal?</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Experience:</span>&nbsp;Our team is highly trained and
                    experienced in handling all types of appliance disposal,
                    including heavy appliances like old refrigerators and
                    washing machines.
                  </li>
                  <li>
                    <span>Convenience:</span>&nbsp;We offer flexible scheduling,
                    including same-day service and next day pick up options.
                  </li>
                  <li>
                    <span>Affordability: </span>&nbsp;Get a free estimate and
                    transparent pricing with no hidden fees. Our appliance
                    removal cost is budget-friendly and competitive.
                  </li>
                  <li>
                    <span>Eco-Friendly Practices:</span> &nbsp;We prioritize
                    friendly disposal, working with local charities such as
                    Habitat for Humanity and recycling facilities to ensure
                    environmentally responsible waste management.
                  </li>
                  <li>
                    <span>Customer Satisfaction:</span>&nbsp;From start to
                    finish, we’re committed to providing a seamless, stress-free
                    removal process.
                  </li>
                </p>
                {/* ============ */}
                <h3>
                  How It
                  <span className="ms-3">Works</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Get a Free Quote:</span>&nbsp;Contact us for a free
                    estimate.
                  </li>
                  <li>
                    <span>Schedule Your Cleanout:</span>&nbsp;Choose a time that
                    works for you, including same-day appointments.
                  </li>
                  <li>
                    <span>We Handle the Heavy Lifting:</span>&nbsp;Our junk
                    removal teams will arrive with the necessary equipment to
                    remove all unwanted junk and debris.
                  </li>
                  <li>
                    <span>Payment:</span>&nbsp;We take payment in cash, debit,
                    credit,check or zelle
                  </li>
                  <li>
                    <span>Eco-Friendly Disposal:</span>&nbsp;We ensure items are
                    donated to local charities or disposed of responsibly.
                  </li>
                </p>
                {/* ===================================================================================0 */}
                <h3>
                  Old Appliance Removal <span>Service Area</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  We proudly serve apartment homes, apartments, businesses and
                  surrounding areas, including:
                </p>
                {/* ===================================================================================0 */}
                <ServicesArea />
                <div className="row">
                  <div className="col-md-12 overview-sec service-desc">
                    <h3 className="pt-0">
                      Ready to Remove <span>Your Old Appliances?</span>
                    </h3>
                    <div class="sliderline-svg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="4"
                        viewBox="0 0 64 4"
                        fill="none"
                      >
                        <path
                          d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                          fill="#60BDFF"
                        ></path>
                      </svg>
                    </div>
                    <p>
                      {" "}
                      Whether you’re upgrading your home with new appliances,
                      clearing out a rental property, or just need to dispose of
                      unwanted items, we make the process effortless. Contact us
                      today for a free estimate and let us handle the heavy
                      lifting for you!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ================== First  Section End HERE =========================  */}
        {/* ================= What We Take Section Start Here ================= */}
        <div className="container-fluid more-detail-sec we-take-sec pt-0">
          <div className="container junk-container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="what-we-head">What We Remove</h2>
                <div className="line-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>Our comprehensive services include:</p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card">
                  <h4>Kitchen Appliances</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Refrigerators and freezers</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Commercial Refrigerators</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Ovens and stoves</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Microwaves</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Dishwashers</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>
                        Small kitchen appliances (blenders, toasters, etc.)
                      </span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card bbq-card-sect">
                  <h4>Laundry Appliances</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Washing machines</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Dryers</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Dryer sets</span>
                    </div>
                  </li>
                </div>
              </div>
              {/*  */}
              <div className="col-lg-4 col-md-6">
                <div className="price-card bbq-card bbq-card-sect other-appliance-sec">
                  <h4>Other Appliances</h4>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Water heaters</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Air conditioners</span>
                    </div>
                  </li>
                  <li>
                    <div className="bbq-list-sec">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-check-lg"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                      </svg>
                      <span>Hot tubs (in some cases)</span>
                    </div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ===================== What We Take Section End Here ================ */}
        {/* ================== Before/After Section Start HERE =========================  */}
        <div className="container after-sec">
          <div className="row">
            <h2>
              <span>Before &amp; After</span> | Appliance Removal
            </h2>
            <div className="sliderline-svg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={64}
                height={4}
                viewBox="0 0 64 4"
                fill="none"
              >
                <path
                  d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                  fill="#60BDFF"
                />
              </svg>
            </div>
            <div className="col-md-6 before-sec">
              <img
                src="/assets/img/before-apliance-removal.webp"
                alt="Before appliance removal"
                width="100%"
                loading="lazy"
              />
              <center>
                <button type="button" className="btn">
                  BEFORE
                </button>
              </center>
            </div>
            <div className="col-md-6 before-sec">
              <img
                src="/assets/img/after-apliance-removal.webp"
                alt="After appliance removal"
                width="100%"
                loading="lazy"
              />
              <center>
                <button type="button" className="btn">
                  After
                </button>
              </center>
            </div>
          </div>
        </div>
        {/* ================== FAQ's Section Start HERE =========================  */}
        <div className="container faq-sec">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h2>
                  Appliance Removal <span>FAQs</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              <ApplianceRemovalFAQs />
            </div>
          </div>
        </div>
        <UpperFooter />
      </>
    </div>
  );
}

export default ApplianceRemoval;
